export default "__VITE_ASSET__52nz_afn__"